import { type ButtonHTMLAttributes, forwardRef } from 'react'
import { cn } from '../lib/cn.ts'
import { buttonVariants, type ButtonVariants } from './Button.variants.ts'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement>, ButtonVariants {}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { className, variant, size, type = 'button', ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  )
})
